import { type ILinePricing, type IShopifyLineItem, type IShopifyProduct } from "@types";

const getNonPartnerLinePrice = (
  line: IShopifyLineItem,
  nonPartnerProducts: IShopifyProduct[] | undefined,
): number | undefined => {
  const price = nonPartnerProducts
    ?.find((product) => product.productType === line.productType)
    ?.variants.find((variant) => variant.purchaseType === line.purchaseType)?.price;

  return price == null ? undefined : Number(price);
};

// Pairs each line with its full price, kept only when higher than the discounted line price.
export const getLinePricing = (
  lines: IShopifyLineItem[],
  nonPartnerProducts: IShopifyProduct[] | undefined,
): ILinePricing[] =>
  lines.map((line) => {
    const nonPartnerLinePrice = getNonPartnerLinePrice(line, nonPartnerProducts);
    const nonPartnerPrice =
      nonPartnerLinePrice != null && nonPartnerLinePrice > Number(line.linePrice) ? nonPartnerLinePrice : undefined;

    return { line, nonPartnerPrice };
  });

// Subtotal before the partner discount: full price where known, line price otherwise.
export const getCartSubtotal = (linePricing: ILinePricing[]): number =>
  linePricing.reduce((sum, { line, nonPartnerPrice }) => sum + (nonPartnerPrice ?? Number(line.linePrice)), 0);
